
(function ($) {

  $.fn.selectEmbedUrl = function () {

    const embedButton = $('.infoGraph-embed-btn');

    embedButton.on('click', function () {

      let embedContainer = $(this).parents('.buttoncontainer').next('.embed-container');
      let embedTooltip = $(this).next('.embed-tooltip');
      let embedTextarea = embedContainer.children('textarea').attr('id');

      embedContainer.toggleClass('show');
      
      if (embedContainer.hasClass('show')) {
        const timeoutIN = 400;
        const timeoutOUT = 3400;

        embedContainer.attr('aria-hidden', 'false').children('textarea').removeAttr('tabindex');

        //copy textarea content (won't work while element is hidden or set to height/width 0 )
        setTimeout(function () {
          document.getElementById(embedTextarea).select();
          document.execCommand('copy');
        }, timeoutIN);

        //control tooltip
        setTimeout(function () {
          embedTooltip.tooltip('show');
        }, timeoutIN);
        
        setTimeout(function () {
          embedTooltip.tooltip('hide');
        }, timeoutOUT);

      }
      else {

        embedContainer.attr('aria-hidden', 'true').children('textarea').attr('tabindex', '-1');

        //reset textarea content
        document.getElementById(embedTextarea).blur();

        //reset tooltip
        embedTooltip.tooltip('hide');

      }

    });

    function infographic_layout_checker() {

      //button layout
      $('.infographicblock').each(function () {

        const downloadbutton = $(this).find('.infoGraph-download-btn');
        const infographicbutton = $(this).find('.infographic-embed-btn-container');

        infographicbutton.removeClass('floatleft');

        if (downloadbutton.length > 0 && infographicbutton.length > 0) {

          if (infographicbutton.position().top != downloadbutton.position().top) {
            infographicbutton.addClass('floatleft');
          }

        }
      });

      //set textarea dynamic height - you can't actually set this with css
      $('.infographic-embed-code-text').attr('style', '');
      $('.infographic-embed-code-text').each(function () {
        this.setAttribute('style', 'height:' + (this.scrollHeight) + 'px;overflow-y:hidden;');
      });

    }

    infographic_layout_checker();

    $(window).on('resize-end', function () {
      infographic_layout_checker();
    });

  }
}(jQuery));
